import { render, staticRenderFns } from "./attorney-arranged-paid-transfer-stamps.vue?vue&type=template&id=784fb555"
import script from "./attorney-arranged-paid-transfer-stamps.vue?vue&type=script&lang=js"
export * from "./attorney-arranged-paid-transfer-stamps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports